export default __webpack_public_path__ + "static/media/cq.e55334af.png";